import { UI } from '@/shared/design-system/tactical-ui';
import React from 'react';
import { Moon } from 'lucide-react';
import { ModalWrapper } from './ModalWrapper';

interface SleepConfirmModalProps {
    onClose: () => void;
    onConfirm: () => void;
}

export const SleepConfirmModal: React.FC<SleepConfirmModalProps> = ({ onClose, onConfirm }) => (
    <ModalWrapper onClose={onClose} borderColor="#3b82f6">
        <div style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
            <Moon size={32} color="#3b82f6" fill="#3b82f6" />
        </div>
        <h2 style={{ ...UI.text.title, fontSize: 18, margin: "0 0 10px" }}>START RECOVERY?</h2>
        <p style={{ fontSize: '13px', color: '#888', margin: '0 0 25px' }}>Initiating Sleep Protocol. SYSTEM will enter low-power mode.</p>
        <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={onClose} style={{ flex: 1, padding: '14px', borderRadius: '10px', border: '1px solid #333', backgroundColor: 'transparent', color: '#fff', fontWeight: '900', fontSize: '12px', textTransform: 'uppercase' }}>Cancel</button>
            <button onClick={onConfirm} style={{ flex: 1, padding: '14px', borderRadius: '10px', border: 'none', backgroundColor: '#3b82f6', color: '#fff', fontWeight: '900', fontSize: '12px', textTransform: 'uppercase' }}>Initiate</button>
        </div>
    </ModalWrapper>
);
